import axios from "axios";
const baseUrl = process.env.REACT_APP_API_URL;
const quizUrl = process.env.REACT_APP_QUIZ_URL || process.env.REACT_APP_API_URL;

const getBaseUrl = (path) => {
    if (path.startsWith('quiz/')) {
        return quizUrl;
    }
    return baseUrl;
};

const handleUnauthorized = (error) => {
    if (error?.response?.status !== 401) return;

    // Full cleanup on auto-logout to avoid stale app state.
    localStorage.clear();
    window.location.href = '/login';
};

const apiService = {
    get: async (path) => {
        try {
            const url = getBaseUrl(path);
            var { success } = await axios.get(url + path);
            return [success, null]
        } catch (error) {
            handleUnauthorized(error);
            return [null, error]
        }
    },

    put: async (path, data) => {
        try {
            const url = getBaseUrl(path);
            var { success } = await axios.put(url + path, data);
            return [success, null]
        } catch (error) {
            handleUnauthorized(error);
            return [null, error]
        }
    },

    post: async (path, data) => {
        try {
            const url = getBaseUrl(path);
            var { success } = await axios.post(url + path, data);
            return [success, null]
        } catch (error) {
            handleUnauthorized(error);
            return [null, error]
        }
    },

    delete: async (path) => {
        try {
            const url = getBaseUrl(path);
            var { success } = await axios.delete(url + path);
            return [success, null]
        } catch (error) {
            handleUnauthorized(error);
            return [null, error]
        }
    },

    patch: async (path, data) => {
        try {
            const url = getBaseUrl(path);
            var { success } = await axios.patch(url + path, data);
            return [success, null]
        } catch (error) {
            handleUnauthorized(error);
            return [null, error]
        }
    }
  };
  
export default apiService;